<template>
  <button @click="exportPlanOrder" class="btn btn-primary mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <div class="text-center">
        <b-spinner></b-spinner>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';

export default {
  props: ['data', 'sum', "avg", "label", "group"],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportPlanOrder: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);
      if (this.sum) {
        let row = this.sum;
        row.label = this.$t('total');
        sheet.addRow(row);
      }
      if (this.avg) {
        let row = this.avg;
        row.label = this.$t('average');
        sheet.addRow(row);
      }
      this.data.forEach(item => {
          let row = item;
          row.label = this.label(item);
          row.sales = item.clientSales;
          row.businessCategory = item.clientCategory;
          row.isCared = item.clientSales && !item.clientCareTime ? "Bơ vơ" : "Tự tìm";
          sheet.addRow(row);
          this.downloadedCount += 1;
        });

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'plan-order-report.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      let colunms = [
        {header: '', key: 'label', width: 15},
      ];
      if (this.group === 'client') { 
        colunms.push(
          {header: this.$t('sales'), key: 'sales', width: 15},
          {header: this.$t('businessCategory'), key: 'businessCategory', width: 15},
          {header: this.$t('isCared'), key: 'isCared', width: 15},
        );
      }
      colunms.push(
        {header: this.$t('new'), key: 'new', width: 15},
        {header: this.$t('newUser'), key: 'newUser', width: 15},
        {header: this.$t('user'), key: 'user', width: 15},
        {header: this.$t('additionalUser'), key: 'additionalUser', width: 15},
        {header: this.$t('extend'), key: 'extend', width: 15},
        {header: this.$t('extendTotal'), key: 'extendTotal', width: 15},
        {header: this.$t('extendMonth'), key: 'extendMonth', width: 15},
        {header: this.$t('extendedUser'), key: 'extendedUser', width: 15},
        {header: this.$t('upgrade'), key: 'upgrade', width: 15},
        {header: this.$t('total'), key: 'total', width: 15},
      );
      sheet.columns = colunms;
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        planOrder : 'Plan order',
        byDay: 'By day',
        byWeek: 'By week',
        byMonth: 'By month',
        byClient: 'By client',
        bySales: 'By sales',
        new: 'New',
        user: 'Buy more user',
        extend: 'Extend',
        upgrade: 'Upgrade',
        totals: 'Total',
        average: 'Average',
        selectSales: 'Select sales',
        newUser: 'New user count',
        additionalUser: 'Additional user count',
        extendedUser: 'Extended user count',
        isCared: "Khách bơ vơ",
        extendTotal: "Extend order",
        extendMonth: "Extend months"
      },
      vi: {
        planOrder : 'Đơn hàng gói dịch vụ',
        byDay: 'Theo ngày',
        byWeek: 'Theo tuần',
        byMonth: 'Theo tháng',
        byClient: 'Theo client',
        bySales: 'Theo sales',
        new: 'Mua mới',
        user: 'Mua thêm',
        extend: 'Gia hạn',
        upgrade: 'Nâng cấp',
        totals: 'Tổng',
        average: 'Trung bình',
        selectSales: 'Chọn sales',
        newUser: 'Số user mới',
        additionalUser: 'Số user mua thêm',
        extendedUser: 'Số user gia hạn',
        isCared: "Khách bơ vơ",
        extendTotal: "Số gói gia hạn",
        extendMonth: "Số tháng gia hạn"
      }
    }
  }
}
</script>
